
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AppFooter extends Vue {

  public langs = ['fr', 'en'];

}
